<template>
  <div class="answer-by-myself-container">
    <div class="title-content flex justify-between items-center">
      <div class="title">输入面试问题</div>
      <MemberTips v-if="!isMembership" @buyMember="buyMember" />
    </div>
    <div class="question-input relative">
      <EditorInput v-model="question" placeholder="请输入面试问题" />
      <CompleteBtn :text="''" class="enter-btn" @clickBtn="enter">
        <template v-slot:content>
          <i v-if="state === 'loading'" class="iconfont iconzhengzaibaocun"></i>
          <span v-else>GO</span>
        </template>
      </CompleteBtn>
    </div>
    <div class="flex flex-wrap questions-container">
      <div
        v-for="(item, index) in questions"
        :key="index"
        class="question-item flex items-center"
        :class="{ active: item === question }"
        @click="clickQuestionItem(item)"
      >
        {{ item }}
      </div>
    </div>
    <div class="title-content flex justify-between items-center">
      <div class="title">生成结果</div>
    </div>
    <div class="answer-content" :class="{ empty: !answer }">
      {{ answer || "面试问题结果" }}
    </div>
    <div class="flex justify-between items-center" style="margin-top: 24px">
      <span class="powered-by-chatgpt">Powered By WonderAI</span>
      <div class="flex items-center">
        <CompleteBtn
          :text="''"
          type="cancel"
          class="mock-interview-btn"
          style="width: 104px; margin-right: 16px"
          @clickBtn="enter('retry')"
        >
          <template v-slot:content>
            <div class="content flex items-center">
              <i
                v-if="retryState === 'loading'"
                class="iconfont iconzhengzaibaocun"
              ></i>
              {{ retryState === "loading" ? "AI 思考中" : "重试" }}
            </div>
          </template>
        </CompleteBtn>
        <CompleteBtn
          text="复制结果"
          class="mock-interview-btn"
          @clickBtn="copyAnswer"
        />
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import { mapState } from "vuex";
import MemberTips from "./MemberTips.vue";
import EditorInput from "../EditorInput/EditorInput.vue";
import CompleteBtn from "../CompleteButton/CompleteButton.vue";
import { copyToClipboard } from "@/assets/js/util";

const QUESTIONS = [
  "你认为在工作中你的优点和缺点有哪些？",
  "上一份工作为什么离职？",
  "你的个人核心竞争力是什么？",
  "在5年内，你的职业规划是什么？",
  "为什么选择我们公司？",
  "你怎样看待自己的失败或成功？",
];
export default {
  name: "AnswerByMyself",
  data() {
    return {
      questions: QUESTIONS,
      question: "",
      answer: "",
      state: "",
      retryState: "",
    };
  },
  components: {
    MemberTips,
    EditorInput,
    CompleteBtn,
  },
  computed: {
    ...mapState("me", ["isMembership"]),
  },
  methods: {
    buyMember() {
      this.$emit("buyMember");
    },
    clickQuestionItem(item) {
      this.question = item;
    },
    async copyAnswer() {
      await copyToClipboard(this.answer);
      this.$message.success("复制成功");
    },
    async enter(type) {
      if (!this.question) {
        this.$message.warning("请输入面试问题");
        return;
      }
      if (!this.isMembership) {
        this.$emit("buyMember");
        return;
      }
      if (this.state === "loading" || this.retryState === "loading") return;
      type === "retry"
        ? (this.retryState = "loading")
        : (this.state = "loading");
      this.answer = "";
      api.cvsEditor.fetchMockInterviewResultStream({
        data: {
          cv_token: this.$store.state.editor.cvDetail.basic_info.token,
          ask_type: "my_answer",
          question: this.question,
        },
        onMessage: (data = {}) => {
          if (data?.choices?.length) {
            data.choices.forEach((item) => {
              if (item?.delta?.content) {
                this.answer += item.delta.content;
              }
            });
          }
        },
        onComplete: () => {
          this.state = "";
          this.retryState = "";
        },
        onError: (error) => {
          console.log(error);
          this.state = "error";
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.answer-by-myself-container {
  padding: 24px 18px;
  background: $form-bg-color;
  border-radius: 12px;
  .title-content {
    margin-bottom: 24px;
    .title {
      color: $text-color;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .question-input {
    :deep(.el-input__inner) {
      padding-right: 84px;
      border-radius: 8px;
    }
    .enter-btn {
      position: absolute;
      right: 6px;
      top: 50%;
      transform: translateY(-50%);
      width: 62px;
      height: 32px;
      border-radius: 6px;

      .iconfont {
        font-size: 14px;
        animation: spin 2s linear infinite;
      }
    }
  }
  .questions-container {
    margin-top: 16px;
    gap: 10px;
    margin-bottom: 32px;
    .question-item {
      color: #8d99aa;
      font-size: 12px;
      font-weight: 400;
      padding: 0 12px;
      height: 28px;
      border: 1px solid #8d99aa;
      border-radius: 999px;
      cursor: pointer;
      &.active,
      &:hover {
        border-color: $theme-color;
        color: $theme-color;
      }
    }
  }
  .answer-content {
    background-color: $page-bg-sub-color;
    border-radius: 8px;
    padding: 18px;
    height: 320px;
    overflow-y: auto;
    color: $text-color;
    font-size: 14px;
    font-weight: 400;
    white-space: pre-line;
    &::-webkit-scrollbar {
      display: none;
    }
    &.empty {
      color: $placeholder-color;
    }
  }
  .mock-interview-btn {
    border-radius: 18px;
    width: 132px;
    height: 36px;
    font-size: 14px;
    white-space: nowrap;
    .content {
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
        animation: spin 2s linear infinite;
      }
    }
  }
  .powered-by-chatgpt {
    color: $powered-by-chatgpt;
    font-size: 12px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
